var map = {
	"./css/app.css": "557b",
	"./data/papers": "a381",
	"./data/papers.json": "a381",
	"./data/projects": "996c",
	"./data/projects.json": "996c",
	"./data/unused": "a9c9",
	"./data/unused.json": "a9c9",
	"./fonts/Nunito/Nunito-Italic-VariableFont_wght.ttf": "0af3",
	"./fonts/Nunito/Nunito-VariableFont_wght.ttf": "ab83",
	"./fonts/Nunito/OFL.txt": "140d",
	"./fonts/Nunito/README.txt": "5851",
	"./fonts/Nunito/static/Nunito-Black.ttf": "3610",
	"./fonts/Nunito/static/Nunito-BlackItalic.ttf": "c9ad",
	"./fonts/Nunito/static/Nunito-Bold.ttf": "b626",
	"./fonts/Nunito/static/Nunito-BoldItalic.ttf": "3a2c",
	"./fonts/Nunito/static/Nunito-ExtraBold.ttf": "eda5",
	"./fonts/Nunito/static/Nunito-ExtraBoldItalic.ttf": "e0ff",
	"./fonts/Nunito/static/Nunito-ExtraLight.ttf": "1f40",
	"./fonts/Nunito/static/Nunito-ExtraLightItalic.ttf": "af67",
	"./fonts/Nunito/static/Nunito-Italic.ttf": "69b2",
	"./fonts/Nunito/static/Nunito-Light.ttf": "9e9d",
	"./fonts/Nunito/static/Nunito-LightItalic.ttf": "3215",
	"./fonts/Nunito/static/Nunito-Medium.ttf": "7a04",
	"./fonts/Nunito/static/Nunito-MediumItalic.ttf": "39bd",
	"./fonts/Nunito/static/Nunito-Regular.ttf": "6b5d",
	"./fonts/Nunito/static/Nunito-SemiBold.ttf": "eb24",
	"./fonts/Nunito/static/Nunito-SemiBoldItalic.ttf": "6486",
	"./fonts/Varela_Round/OFL.txt": "3096",
	"./fonts/Varela_Round/VarelaRound-Regular.ttf": "8b03",
	"./gapg-sermons.png": "3ddc",
	"./logo.png": "cf05",
	"./news-app.png": "febe",
	"./requiem.png": "44fd",
	"./todo-list.png": "4f5c",
	"./weather-app.png": "c768",
	"./zero-trust.png": "0aad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";